zpr-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 998;
  display: none;
  background: rgba(56, 82, 109, 0.7);
  display: none;
  align-items: center;
  justify-content: center;
  animation: zpr-modal-fadein 150ms;

  &.open {
    display: flex;
  }

  > .wrapper {
    width: 900px;
    max-height: calc(100vh - 48px);
    max-width: calc(100vw - 32px);
    padding: 32px;
    border-radius: 8px;
    position: relative;
    display: flex;
    flex-direction: column;
    background: white;
    box-shadow: 0px 2px 2px 0px rgba(45, 45, 45, 0.05), 0px 4px 4px 0px rgba(49, 49, 49, 0.05), 0px 8px 8px 0px rgba(42, 42, 42, 0.05), 0px 16px 16px 0px rgba(32, 32, 32, 0.05);

    > [data-modal="close"] {
      height: 32px;
      width: 32px;
      position: absolute;
      top: -10px;
      right: -10px;
      border: 0 none;
      outline: none;
      border-radius: 50%;
      background-color: white;

      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 16px;
        height: 2px;
        margin: -1px 0 0 -8px;
        border-radius: 2px;
        top: 50%;
        left: 50%;
        background-color: color('midnight');
      }

      &::before {
        transform: rotate(45deg);
      }

      &::after {
        transform: rotate(-45deg);
      }

      &:hover {
        background-color: color('snow');
      }
      
      &[hidden] {
        display: none;
      }
    }
  }

  > .wrapper, zpr-modal-step {
    > header {
      display: flex;
      padding: 0 0 16px 0;

      &:empty {
        padding: 0;
      }

      h2, h3, h4 {
        margin: 0;
      }
    }

    > main {
      overflow-y: auto;
    }

    > footer {
      padding: 32px 0 0 0;
      display: flex;
      justify-content: right;
      align-items: center;

      &:empty {
        padding: 0;
      }

      .btn + .btn {
        margin: 0 0 0 16px;
      }
    }
  }

  &[noscroll]{
    > .wrapper, zpr-modal-step {
      > main {
        overflow-y: visible;
      }
    }
  }

  &.small > .wrapper {
    width: 600px;
  }

  &.large > .wrapper {
    width: 1100px;
  }
  
  // &.w1008 > .wrapper {
  //   width: 1008px;
  // }
  
  // &.fixed-height > .wrapper {
  //   height: 80vh;
  //   > main {
  //     height: 100%;
  //     overflow-y: hidden;
  //   }
  // }
}

@keyframes zpr-modal-fadein {
  from { opacity: 0; }
  to { opacity: 1; }
}
